export default __webpack_public_path__ + "static/media/100.81e1b5c8.png";